<template>
    <div class="equity-common-content">
        <div class="e-common-frames">
            <div class="e-top e-common-block">
                <div class="e-common-lr">
                    <div class="e-left">
                          <img src="@/assets/images/e-jchy-icon@2x.png" alt="">
                    </div>
                    <div class="e-right">
                        <h3>洁齿护牙服务 </h3>
                        <p>您每年免费享受高端齿科诊所的洁齿护牙服务,可在“成人洁牙”、“儿童牙窝沟封闭(2颗)、“儿童全口涂氟”三项中选择一项。</p>
                    </div>
                </div>
            </div>
            <div class="e-bottom e-common-block">
                <h2>温馨提示</h2>
                <p class="bold">细则1</p>
                <p>世界白金鑫卡持卡人全年尊享1次洁牙护齿服务,并可转赠亲友使用。</p>
                <p class="bold">细则2</p>
                <p>本行将在您激活人民币卡后的3个工作日内为您开通权益服务。</p>
                <p class="bold">细则3</p>
                <p>请提前 3个工作日通过本行信用卡微信公众号权益平台预约服务；供应商将在您生成电子券码后两个工作日内联系您预留的电话号码,确认订单详情。如您需要预约周末服务,请提前两周时间预约；如您需要修改或取消该服务,请务必提前1个工作日通过微信公众号权益平台取消,否则视作您已使用本次服务, 并扣减相应权益。我行将在2个工作日内和您确认预订信息。</p>
                <p class="bold">细则4</p>
                <p>诊所服务时间为周一至周日(9:00-18:00),具体服务时间以各诊所实际公示时间为准,节假日服务时间调整将根据诊所要求另行安排。</p>
                <p class="bold">细则5</p>
                <p>使用人到达预约指定诊所后,只需出示使用人本人身份证明文件,即可享受由齿科专业医护团队所提供的服务。</p>
                <p class="bold">细则6</p>
                <p>洁齿护牙服务诊所信息将不定期更新或调整,具体诊所信息以本行信用卡微信公众号服务预约显示为准。</p>
            </div>
            <div class="banner-detail-btn" @click="jchyPush"><img src="@/assets/images/bjx/banner_bjx_jchy.jpg" alt=""></div>
        </div>
    </div>
</template>

<script>
    export default {
          methods: {
            jchyPush() {
                this.$test('bjx jchy-banner')
                // console.log('白金鑫洁齿护牙')
                this.$router.push('/servicetable/jchy')
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>